// Slides are authored at the Reveal.js native deck size (see RevealRenderer);
// previews render this fixed stage and scale it down to fit.
export const SLIDE_WIDTH = 960;
export const SLIDE_HEIGHT = 700;
